// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 POST /app/user/exportToExcel */
export async function exportToExcel(
  body: API.UserQueryDto,
  options?: { [key: string]: any },
) {
  return request<string>('/app/user/exportToExcel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/user/getPagedListAysnc */
export async function getPagedListAysnc(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetPagedListAysncParams,
  options?: { [key: string]: any },
) {
  return request<API.PagedResultDto1UserDto>('/app/user/getPagedListAysnc', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/user/getSystemUser */
export async function getSystemUser(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetSystemUserParams,
  options?: { [key: string]: any },
) {
  return request<API.UserDto>('/app/user/getSystemUser', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 PUT /app/user/updateUser */
export async function updateUserAsync(
  body: API.UserDto,
  options?: { [key: string]: any },
) {
  return request<API.UserDto>('/app/user/updateUser', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
